export const HTTPStatusCode = {
    REQUEST_TIMEOUT: 408,
    CANCELED: 499,
}
